import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/wallet-request`;

class WalletRequestServices {
  async getWalletRequestList(page, limit, filter, status, fromDate, toDate) {
    try {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
      });
      if (filter) params.set("filter", filter);
      if (status) params.set("status", status);
      if (fromDate) params.set("from_date", fromDate);
      if (toDate) params.set("to_date", toDate);
      const response = await requestToken.get(
        `${API_ROUTE}/get-wallet-request-list?${params.toString()}`,
      );
      return response;
    } catch (error) {
      console.error("Error in getWalletRequestList:", error);
      throw error;
    }
  }

  async createWalletRequest(payload) {
    try {
      const action = `${API_ROUTE}/create`;
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in createWalletRequest:", error);
      throw error;
    }
  }

  async approveWalletRequest({ id, admin_remark }) {
    try {
      const action = `${API_ROUTE}/approve`;
      return await requestToken.post(action, { id, admin_remark });
    } catch (error) {
      console.error("Error in approveWalletRequest:", error);
      throw error;
    }
  }

  async rejectWalletRequest({ id, admin_remark }) {
    try {
      const action = `${API_ROUTE}/reject`;
      return await requestToken.post(action, { id, admin_remark });
    } catch (error) {
      console.error("Error in rejectWalletRequest:", error);
      throw error;
    }
  }

  async deleteWalletRequest(id) {
    try {
      const action = `${API_ROUTE}/delete`;
      return await requestToken.post(action, { id });
    } catch (error) {
      console.error("Error in deleteWalletRequest:", error);
      throw error;
    }
  }
}

export default WalletRequestServices;